import { ChakraProvider, useBoolean, useDisclosure } from "@chakra-ui/react";
import Form from "@rjsf/core";
import { useState } from "react";
import { Button } from "../../components/button/Button";
import Dialog from "../../components/dialog/Dialog";
import DialogMessage from "../../components/dialog/DialogMessage";
import { lang } from "../../Utils";
import { createSupport, getForms } from "./Services";
import FullPageLoader from "../../components/loader/FullPageLoader";

const Index = ({ attributes }) => {

  const [loader, setLoader] = useBoolean(false);
  const [form, setForm] = useState();
  const { isOpen: isOpenForm, onOpen: onOpenForm, onClose: onCloseForm } = useDisclosure();
  const { isOpen: isOpenSuccess, onOpen: onOpenSuccess, onClose: onCloseSuccess } = useDisclosure();
  const { isOpen: isOpenFailure, onOpen: onOpenFailure, onClose: onCloseFailure } = useDisclosure();

  const onClick = () => {
    if (!!form) {
      onOpenForm();
    } else {
      getForms(attributes.slug)
        .then(data => {
          Object.entries(data.frmschema.properties).forEach(el =>
            data.frmschema.properties[el[0]].title = lang(el[1].title)
          );
          setForm(data);
          onOpenForm();
        })
    }
  };

  const onFormSubmit = ({ formData }, e) => {
    onCloseForm();
    setLoader.on();
    createSupport(formData)
      .then(_ => onOpenSuccess())
      .catch(_ => onOpenFailure())
      .finally(_ => setLoader.off());
  }

  return (<ChakraProvider>
    {(!loader) ? <>
      <Button variant="default" onClick={onClick}>{lang(attributes.label)}</Button>
      <Dialog title={lang("Contact Us")} isOpen={isOpenForm} onClose={onCloseForm}>
        <Form
          className="bf-support-form"
          schema={form?.frmschema}
          uiSchema={form?.uischema}
          onSubmit={onFormSubmit}>
          <div className="bf-support-form-action">
            <Button type="submit">{lang('Submit')}</Button>
          </div>
        </Form>
      </Dialog>
      <DialogMessage
        isOpen={isOpenSuccess} onClose={onCloseSuccess}
        title={lang('Support Create')}
        variant={'success'}>
        {lang('Thank you. Your ticket is correctly submitted, our support is in English')}
      </DialogMessage>
      <DialogMessage
        isOpen={isOpenFailure} onClose={onCloseFailure}
        title={lang('Support Error')}
        variant={'error'}>
        {lang('We are an error when send your support request, please try again')}
      </DialogMessage>
    </> : <FullPageLoader />}
  </ChakraProvider>)
}

export { Index } 